export const COMMENT_LIST_ATTEMPT = "COMMENT_LIST_ATTEMPT";
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAILED = "COMMENT_LIST_FAILED";
//////////////////
export const COMMENT_NEW_SUCCESS = "COMMENT_NEW_SUCCESS";
export const COMMENT_NEW_FAILED = "COMMENT_NEW_FAILED";
//////////////////
export const COMMENT_LIKE_SUCCESS = "COMMENT_LIKE_SUCCESS";
export const COMMENT_LIKE_FAILED = "COMMENT_LIKE_FAILED";

export const COMMENT_SET_ITEM = "COMMENT_SET_ITEM";
///////////////
export const COMMENT_MORELIST_ATTEMPT = "COMMENT_MORELIST_ATTEMPT";
export const COMMENT_MORELIST_SUCCESS = "COMMENT_MORELIST_SUCCESS";
export const COMMENT_MORELIST_FAILED = "COMMENT_MORELIST_FAILED";

export const COMMENT_REMOVE_SUCCESS = "COMMENT_REMOVE_SUCCESS";
export const COMMENT_REMOVE_FAILED = "COMMENT_REMOVE_FAILED";


